import Cookies from "universal-cookie";

const setCookie = (token: string) => {
  const cookies = new Cookies();
  cookies.set("authToken", token, { maxAge: 86400 });
  window.location.href = "/home";
};
export default setCookie;
